'use client';

import React, { Suspense } from 'react';
import { useInView } from 'react-intersection-observer';

const LazyComponent = ({ children, fallback = <div>Loading...</div>, threshold = 0.1, triggerOnce = true, rootMargin = '0px' }) => {
  const { ref, inView } = useInView({
    threshold,
    triggerOnce,
    rootMargin,
  });

  return <div ref={ref}>{inView ? <Suspense fallback={fallback}>{children}</Suspense> : fallback}</div>;
};

export default LazyComponent;
